import {FC} from 'react'
import {getInvoiceSubjectRules, INVOICE_SUBJECTS, InvoiceSubject} from '../core/invoiceSubject'

type Props = {
  subject: InvoiceSubject
  compact?: boolean
  className?: string
}

const InvoiceSubjectGuide: FC<Props> = ({subject, compact = false, className = ''}) => {
  const definition = INVOICE_SUBJECTS.find((item) => item.id === subject) || INVOICE_SUBJECTS[0]
  const rules = getInvoiceSubjectRules(subject)

  return (
    <section
      className={`mp-invoice-subject-guide is-${definition.tone} ${
        compact ? 'is-compact' : ''
      } ${className}`}
      aria-label={`راهنمای صورتحساب ${definition.title}`}
    >
      <span className='mp-invoice-subject-guide__icon' aria-hidden='true'>
        <i className={`las ${definition.icon}`}></i>
      </span>
      <div>
        <strong>نکات دستورالعمل برای صورتحساب {definition.title}</strong>
        <ul>
          {(compact ? rules.slice(0, 2) : rules).map((rule) => (
            <li key={rule}>{rule}</li>
          ))}
        </ul>
      </div>
    </section>
  )
}

export {InvoiceSubjectGuide}
